import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home'
import PageNotFound from '@/components/PageNotFound'
import About from '@/components/About'
import Portfolio from '@/components/Portfolio'
import ApiTest from '@/components/ApiTest'
import Sail from '@/components/Sail'
import Posts from '@/components/Posts'

Vue.config.productionTip = false

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/about',
      name: 'About',
      component: About
    },
    {
      path: '/portfolio',
      name: 'Portfolio',
      component: Portfolio
    },
    {
      path: '/murder',
      name: 'ApiTest',
      component: ApiTest
    },
    {
      path: '/sail',
      name: 'Sail',
      component: Sail
    },
    {
      path: '/posts',
      name: 'Posts',
      component: Posts
    },
    {
      path: '*',
      component: PageNotFound
    }
  ]
})
